import { useState } from "react";
import { motion } from "framer-motion";
import "../../App.css"
import * as api from "../../api/index";

const DonationForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    amount: "",
    message: "",
    phone:"",
    donationType: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async(e) => {
    e.preventDefault();
    console.log("Form Submitted", formData);
    try{
    const response = await api.donateForm(formData);
    if(response.data){
        alert("Form successfully submitted");
    }
    setFormData({
        name: "",
        email: "",
        amount: "",
        phone: "",
        message: "",
        donationType: "",
      });
    }catch(error){
        console.log(error);
        alert("something went wrong from our side , please try again after some time");
    }
  };

  return (
    <div
      className="flex justify-center items-center min-h-screen bg-gradient-to-br from-indigo-400 via-purple-400 to-pink-400 relative p-6 donation-form-img"
    >
      
      <motion.div
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="max-w-lg w-full rounded-3xl shadow-2xl p-8 relative z-10"
      >
        <h1 className="text-4xl font-extrabold text-center text-purple-700 mb-6">
          Help Us Make a Difference 🐾
        </h1>
        <p className="text-gray-600 text-center mb-8 leading-relaxed">
          Every donation helps us provide food, medical care, and shelter for
          our furry friends. Your kindness matters!
        </p>
        <form onSubmit={handleSubmit} className="space-y-6 donation-form" >
          <div>
            <label
              className="block text-lg font-medium text-gray-700 mb-2"
              htmlFor="name"
            >
              Name
            </label>
            <input
              id="name"
              name="name"
              type="text"
              value={formData.name}
              onChange={handleInputChange}
              placeholder="Your Full Name"
              className="w-full px-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-4 focus:ring-purple-500 transition"
              required
            />
          </div>

          <div>
            <label
              className="block text-lg font-medium text-gray-700 mb-2"
              htmlFor="email"
            >
              Email
            </label>
            <input
              id="email"
              name="email"
              type="email"
              value={formData.email}
              onChange={handleInputChange}
              placeholder="Your Email Address"
              className="w-full px-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-4 focus:ring-purple-500 transition"
              required
            />
          </div>

          <div>
            <label
              className="block text-lg font-medium text-gray-700 mb-2"
              htmlFor="amount"
            >
              Donation Amount (₹)
            </label>
            <input
              id="amount"
              name="amount"
              type="number"
              value={formData.amount}
              onChange={handleInputChange}
              placeholder="Enter Amount in INR"
              className="w-full px-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-4 focus:ring-purple-500 transition"
              required
            />
          </div>
          <div>
            <label
              className="block text-lg font-medium text-gray-700 mb-2"
              htmlFor="phone"
            >
            Phone
            </label>
            <input
              id="phone"
              name="phone"
              type="number"
              value={formData.phone}
              onChange={handleInputChange}
              placeholder="phone"
              className="w-full px-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-4 focus:ring-purple-500 transition"
              required
            />
          </div>

          <div>
            <label
              className="block text-lg font-medium text-gray-700 mb-2"
              htmlFor="donationType"
            >
              Donation Type
            </label>
            <select
              id="donationType"
              name="donationType"
              value={formData.donationType}
              onChange={handleInputChange}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-4 focus:ring-purple-500 transition"
              required
            >
              <option value="" disabled>
                Select Donation Type
              </option>
              <option value="food">Food</option>
              <option value="medical">Medical</option>
              <option value="shelter">Shelter</option>
              <option value="general">General</option>
            </select>
          </div>

          <div>
            <label
              className="block text-lg font-medium text-gray-700 mb-2"
              htmlFor="message"
            >
              Message
            </label>
            <textarea
              id="message"
              name="message"
              value={formData.message}
              onChange={handleInputChange}
              placeholder="Write a heartfelt message (Optional)"
              className="w-full px-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-4 focus:ring-purple-500 transition"
            ></textarea>
          </div>

          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            type="submit"
            className="stylish-button w-full bg-purple-600 text-white py-3 rounded-lg shadow-md hover:bg-purple-700 focus:outline-none focus:ring-4 focus:ring-purple-500 transition"
          >
            Donate Now
          </motion.button>
        </form>
      </motion.div>
    </div>
  );
};

export default DonationForm;
